import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { WikiSearch } from 'Guide/wiki_search';
import AjaxIO from 'Shared/utils';
import { Box, Button, useToast } from '@chakra-ui/react';
import { useState } from 'react';
import { _js } from '@ifixit/localize';

function ParentWikiSearch() {
   const [isEditing, setIsEditing] = useState(false);
   const toast = useToast();

   function saveParent(device) {
      new AjaxIO('saveWikiArea', {
         onSuccess: function (response) {
            if (response.error) {
               toast({
                  title: 'Error',
                  description: response.message,
                  status: 'error',
                  isClosable: true,
                  duration: 3000,
               });
            } else {
               window.location.reload();
            }
         },
      }).send(App.wikiid, device);
   }

   return (
      <Box my={4}>
         {isEditing ? (
            <WikiSearch
               inputClassName={'th_parentTitle'}
               namespace={'topic'}
               placeHolder={_js('Select new parent category')}
               buttonType={'Save'}
               onNewDeviceSelected={({ query }) => saveParent(query)}
               onKnownDeviceSelected={({ selectedItem }) => saveParent(selectedItem.device)}
            />
         ) : (
            <Button onClick={() => setIsEditing(true)}>{_js('Edit')}</Button>
         )}
      </Box>
   );
}

initializeChakraComponent('ParentWikiSearch', ParentWikiSearch);
